/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/DebouncedModel.js");

module.exports = Model({
	name: "collapsibles",

	init: init,
	triggers: triggers,

	handle_toggle: handle_toggle,
	reset: reset
});

function init() {
	this.reset();
}

function triggers() {
	return {
		"toggle": handle_toggle,
		"reset": reset
	};
}

function handle_toggle(item) {
	var change = item.section;
	var old = this.data[change];
	var update = {};
	update[change] = !old;
	this.extend(update);
}

//  Default settings for various page sections
function reset() {
	this.push({
		"managedpermissions_careplan_display": true,
		"managedpermissions_aetonix_display": true,
		"managedpermissions_groupforms_display": true
	});
}
